import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { from } from 'rxjs';
import { RequestsServices } from './requests.service';
import { ICashbackPage, ICashbackPartner } from '../interfaces/cashback';

@Injectable()
export class CashbackService {

  constructor(public request: RequestsServices) {}

  listPartners(params: { skip: number; limit: number; search?: string }): Observable<ICashbackPage<ICashbackPartner>> {
    return from(this.request.get({path: 'cashback', params, endPoint: '/partners'}));
  }
}
